import { useHookstate } from "@hookstate/core";
import { ProgressSpinner } from "primereact/progressspinner";
import React, { useContext, useEffect, useState } from "react";
import { getCountries, getScrbData } from "../../service/ScrbService";
import { StructureContext } from "../../structure-context";
import { allCountries, loadCoffrets, loadInstallations, loadTourneeInstallations, scrbData } from "./ScrbTools";
import ListeCoffrets from "./coffrets/ListeCoffrets";
import ListInstallations from "./installation/ListInstallations";
import Tournees from "./reception/Tournees";
import { globalUserState } from "../../user-context";
import { Informations } from "./informations/Informations";

export default function ScrbMain() {

    const structure = useContext(StructureContext);
    const data = useHookstate(scrbData);
    const countries = useHookstate(allCountries);
    const user = useHookstate(globalUserState).get();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadData();
        window.location.hash === "#/scrb/coffrets" && loadCoffr();
        window.location.hash === "#/scrb/installations" && loadCountries() && loadInst();
        window.location.hash === "#/scrb/tournees" && loadTourneeInst();
        // eslint-disable-next-line
    }, []);

    const loadData = async () => {
        if (data.get() === null || data.get() === undefined) {
            await getScrbData().then(res => {
                data.set(res);
            });
        }
        setLoading(false);
    }

    const loadCountries = async () => {
        await getCountries().then(res => {
            if (user.locale)
                countries.set(res[user.locale.toLowerCase()]);
            else countries.set(res['fr']);
        });
    }

    const loadInst = async () => {
        await loadInstallations(structure.id).then(() => {
            setLoading(false);
        });
    }

    const loadTourneeInst = async () => {
        await loadTourneeInstallations(structure.id).then(() => {
            setLoading(false);
        });
    }

    const loadCoffr = async () => {
        await loadCoffrets(structure.id).then(() => {
            setLoading(false);
        });
    }

    if (loading) {
        return <ProgressSpinner className="flex justify-center" />;
    }

    return (
        <>
            {!loading && data !== null && data !== undefined && data.get() && countries !== null && countries !== undefined && Object.keys(data.get()).length > 0 && window.location.hash === "#/scrb/installations" && <ListInstallations />}
            {!loading && data !== null && data !== undefined && data.get() && countries !== null && countries !== undefined && Object.keys(data.get()).length > 0 && window.location.hash === "#/scrb/tournees" && <Tournees loadTournees={loadTourneeInst} />}
            {!loading && data !== null && data !== undefined && data.get() && Object.keys(data.get()).length > 0 && window.location.hash === "#/scrb/coffrets" && <ListeCoffrets />}
            {!loading && data !== null && data !== undefined && data.get() && Object.keys(data.get()).length > 0 && window.location.hash === "#/" && <Informations />}
        </>
    );
}